// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5552":"3307e12e","5692":"3307e12e","6532":"42a5c5b4"}[chunkId] + ".chunk.css";
};